import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(member)/(public)/join/")({
  beforeLoad: async () => {
    throw redirect({
      to: "/join/sign-up",
      search: (prev) => ({
        ...prev,
        addOns: prev?.addOns || [],
      }),
    });
  },
});
